// Simulated live APY data — gently fluctuates client-side to feel real.
// Bases tuned to the 2026 product registry in /data/products.js
export const apyFeed = [
  { name: "SoFi Savings", base: 3.80, hue: "#00A6FB" },
  { name: "Synchrony HYS", base: 3.30, hue: "#FFC600" },
  { name: "Ally Online Savings", base: 3.00, hue: "#5C1F87" },
  { name: "Capital One 360 Performance", base: 3.00, hue: "#D03027" },
  { name: "Varo Savings", base: 3.75, hue: "#7F39DB" },
  { name: "Apple Bank SmartStart", base: 5.00, hue: "#0A3D62" },
];

export function jitter(base) {
  // ±0.03% noise, two decimals
  const n = base + (Math.random() - 0.5) * 0.06;
  return Math.max(0.1, n).toFixed(2);
}
